export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      booking: "Book Now",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      title: "Professional French-Sinhala Translation",
      subtitle: "Bridging cultures with precision and expertise",
      tagline: "7 years of professional interpreting experience",
      cta: "Book a Slot",
      learnMore: "Learn More",
    },
    // Services
    services: {
      title: "Our Services",
      subtitle: "Professional translation and interpreting solutions",
      videoInterpreting: "Video Interpreting",
      videoDesc: "Real-time video interpretation for meetings, conferences, and remote consultations",
      inPerson: "In-Person Interpreting",
      inPersonDesc: "On-site professional interpretation for business meetings, legal proceedings, and events",
      documentTranslation: "Document Translation",
      documentDesc: "Accurate translation of legal, business, medical, and personal documents",
      perHour: "per hour",
      perHalfDay: "half day",
      perFullDay: "full day",
      perDocument: "per document",
      bookNow: "Book Now",
    },
    // About/Competencies
    about: {
      title: "About Sasmithe Traductions",
      subtitle: "Your trusted partner for French-Sinhala communication",
      experience: "Years of Experience",
      expertise: "Our Expertise",
      competencies: {
        legal: "Legal Translation",
        legalDesc: "Court documents, contracts, certificates, immigration papers",
        business: "Business Interpreting",
        businessDesc: "Corporate meetings, negotiations, trade delegations",
        medical: "Medical Translation",
        medicalDesc: "Medical reports, prescriptions, healthcare communication",
        cultural: "Cultural Mediation",
        culturalDesc: "Understanding nuances between French and Sri Lankan cultures",
      },
      whyChoose: "Why Choose Us",
      reasons: {
        certified: "Certified Professional Translator",
        native: "Native Sinhala Speaker",
        fluent: "Fluent in French & English",
        confidential: "100% Confidentiality Guaranteed",
      },
    },
    // Booking
    booking: {
      title: "Book a Slot",
      subtitle: "Select a service and choose your preferred date",
      selectService: "Select Service",
      selectDate: "Select Date",
      selectTime: "Select Time",
      yourDetails: "Your Details",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      notes: "Additional Notes",
      notesPlaceholder: "Any specific requirements or topics to discuss...",
      continue: "Continue to Payment",
      total: "Total",
      morning: "Morning",
      afternoon: "Afternoon",
      success: {
        title: "Booking Confirmed!",
        message: "Thank you for your booking. You will receive a confirmation email shortly.",
        backHome: "Back to Home",
      },
      cancelled: "Payment was cancelled. Please try again.",
    },
    // Contact
    contact: {
      title: "Get in Touch",
      subtitle: "Have questions? We'd love to hear from you",
      name: "Your Name",
      email: "Your Email",
      subject: "Subject",
      message: "Message",
      send: "Send Message",
      info: {
        title: "Contact Information",
        email: "Email",
        response: "We typically respond within 24 hours",
      },
      success: "Message sent successfully!",
    },
    // Footer
    footer: {
      tagline: "Professional French-Sinhala Translation Services",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      tryAgain: "Try Again",
      back: "Back",
      next: "Next",
      submit: "Submit",
      cancel: "Cancel",
      close: "Close",
    },
  },
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      booking: "Réserver",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      title: "Traduction Professionnelle Français-Cinghalais",
      subtitle: "Relier les cultures avec précision et expertise",
      tagline: "7 ans d'expérience en interprétation professionnelle",
      cta: "Réserver un Créneau",
      learnMore: "En Savoir Plus",
    },
    // Services
    services: {
      title: "Nos Services",
      subtitle: "Solutions professionnelles de traduction et d'interprétation",
      videoInterpreting: "Interprétation Vidéo",
      videoDesc: "Interprétation vidéo en temps réel pour réunions, conférences et consultations à distance",
      inPerson: "Interprétation en Personne",
      inPersonDesc: "Interprétation professionnelle sur site pour réunions d'affaires, procédures juridiques et événements",
      documentTranslation: "Traduction de Documents",
      documentDesc: "Traduction précise de documents juridiques, commerciaux, médicaux et personnels",
      perHour: "par heure",
      perHalfDay: "demi-journée",
      perFullDay: "journée complète",
      perDocument: "par document",
      bookNow: "Réserver",
    },
    // About/Competencies
    about: {
      title: "À Propos de Sasmithe Traductions",
      subtitle: "Votre partenaire de confiance pour la communication français-cinghalais",
      experience: "Années d'Expérience",
      expertise: "Notre Expertise",
      competencies: {
        legal: "Traduction Juridique",
        legalDesc: "Documents judiciaires, contrats, certificats, documents d'immigration",
        business: "Interprétation d'Affaires",
        businessDesc: "Réunions d'entreprise, négociations, délégations commerciales",
        medical: "Traduction Médicale",
        medicalDesc: "Rapports médicaux, ordonnances, communication de santé",
        cultural: "Médiation Culturelle",
        culturalDesc: "Comprendre les nuances entre les cultures française et sri-lankaise",
      },
      whyChoose: "Pourquoi Nous Choisir",
      reasons: {
        certified: "Traducteur Professionnel Certifié",
        native: "Locuteur Natif Cinghalais",
        fluent: "Maîtrise du Français et de l'Anglais",
        confidential: "Confidentialité 100% Garantie",
      },
    },
    // Booking
    booking: {
      title: "Réservez un Créneau",
      subtitle: "Sélectionnez un service et choisissez votre date préférée",
      selectService: "Sélectionner le Service",
      selectDate: "Sélectionner la Date",
      selectTime: "Sélectionner l'Heure",
      yourDetails: "Vos Coordonnées",
      name: "Nom Complet",
      email: "Adresse Email",
      phone: "Numéro de Téléphone",
      notes: "Notes Supplémentaires",
      notesPlaceholder: "Exigences spécifiques ou sujets à discuter...",
      continue: "Continuer vers le Paiement",
      total: "Total",
      morning: "Matin",
      afternoon: "Après-midi",
      success: {
        title: "Réservation Confirmée!",
        message: "Merci pour votre réservation. Vous recevrez un email de confirmation sous peu.",
        backHome: "Retour à l'Accueil",
      },
      cancelled: "Le paiement a été annulé. Veuillez réessayer.",
    },
    // Contact
    contact: {
      title: "Contactez-Nous",
      subtitle: "Des questions? Nous serions ravis de vous entendre",
      name: "Votre Nom",
      email: "Votre Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer le Message",
      info: {
        title: "Informations de Contact",
        email: "Email",
        response: "Nous répondons généralement dans les 24 heures",
      },
      success: "Message envoyé avec succès!",
    },
    // Footer
    footer: {
      tagline: "Services Professionnels de Traduction Français-Cinghalais",
      quickLinks: "Liens Rapides",
      contact: "Contact",
      rights: "Tous droits réservés",
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur s'est produite",
      tryAgain: "Réessayer",
      back: "Retour",
      next: "Suivant",
      submit: "Soumettre",
      cancel: "Annuler",
      close: "Fermer",
    },
  },
  si: {
    // Navigation
    nav: {
      home: "මුල් පිටුව",
      services: "සේවාවන්",
      about: "අප ගැන",
      booking: "වෙන්කරවන්න",
      contact: "සම්බන්ධ වන්න",
    },
    // Hero Section
    hero: {
      title: "වෘත්තීය ප්‍රංශ-සිංහල පරිවර්තනය",
      subtitle: "නිරවද්‍යතාවයෙන් හා විශේෂඥතාවයෙන් සංස්කෘතීන් සම්බන්ධ කිරීම",
      tagline: "වෘත්තීය පරිවර්තන අත්දැකීම් වසර 7ක්",
      cta: "සැසියක් වෙන්කරවන්න",
      learnMore: "තවත් දැනගන්න",
    },
    // Services
    services: {
      title: "අපගේ සේවාවන්",
      subtitle: "වෘත්තීය පරිවර්තන සහ අර්ථකථන විසඳුම්",
      videoInterpreting: "වීඩියෝ අර්ථකථනය",
      videoDesc: "රැස්වීම්, සම්මන්ත්‍රණ සහ දුරස්ථ උපදේශන සඳහා තත්කාලීන වීඩියෝ අර්ථකථනය",
      inPerson: "පුද්ගලික අර්ථකථනය",
      inPersonDesc: "ව්‍යාපාරික රැස්වීම්, නීතිමය කටයුතු සහ උත්සව සඳහා ස්ථානීය අර්ථකථනය",
      documentTranslation: "ලේඛන පරිවර්තනය",
      documentDesc: "නීතිමය, ව්‍යාපාරික, වෛද්‍ය සහ පුද්ගලික ලේඛන නිවැරදි පරිවර්තනය",
      perHour: "පැයකට",
      perHalfDay: "අර්ධ දිනය",
      perFullDay: "සම්පූර්ණ දිනය",
      perDocument: "ලේඛනයකට",
      bookNow: "වෙන්කරවන්න",
    },
    // About/Competencies
    about: {
      title: "Sasmithe Traductions ගැන",
      subtitle: "ප්‍රංශ-සිංහල සන්නිවේදනය සඳහා ඔබේ විශ්වාසවන්ත සහකරු",
      experience: "අත්දැකීම් වසර",
      expertise: "අපගේ විශේෂඥතාව",
      competencies: {
        legal: "නීතිමය පරිවර්තනය",
        legalDesc: "අධිකරණ ලේඛන, ගිවිසුම්, සහතික, ආගමන ලේඛන",
        business: "ව්‍යාපාරික අර්ථකථනය",
        businessDesc: "ආයතනික රැස්වීම්, සාකච්ඡා, වෙළඳ නියෝජිත කණ්ඩායම්",
        medical: "වෛද්‍ය පරිවර්තනය",
        medicalDesc: "වෛද්‍ය වාර්තා, බෙහෙත් වට්ටෝරු, සෞඛ්‍ය සන්නිවේදනය",
        cultural: "සංස්කෘතික මැදිහත්වීම",
        culturalDesc: "ප්‍රංශ සහ ශ්‍රී ලාංකික සංස්කෘතීන් අතර සූක්ෂ්මතා අවබෝධ කර ගැනීම",
      },
      whyChoose: "අප තෝරන්නේ ඇයි",
      reasons: {
        certified: "සහතික ලත් වෘත්තීය පරිවර්තක",
        native: "ස්වදේශික සිංහල කතාකරු",
        fluent: "ප්‍රංශ සහ ඉංග්‍රීසි දක්ෂ",
        confidential: "100% රහස්‍යභාවය සහතික",
      },
    },
    // Booking
    booking: {
      title: "ඔබේ සැසිය වෙන්කරවන්න",
      subtitle: "සේවාවක් තෝරා ඔබට කැමති දිනය තෝරන්න",
      selectService: "සේවාව තෝරන්න",
      selectDate: "දිනය තෝරන්න",
      selectTime: "වේලාව තෝරන්න",
      yourDetails: "ඔබේ විස්තර",
      name: "සම්පූර්ණ නම",
      email: "විද්‍යුත් තැපෑල",
      phone: "දුරකථන අංකය",
      notes: "අමතර සටහන්",
      notesPlaceholder: "විශේෂ අවශ්‍යතා හෝ සාකච්ඡා කළ යුතු මාතෘකා...",
      continue: "ගෙවීමට ඉදිරියට යන්න",
      total: "මුළු මුදල",
      morning: "උදේ",
      afternoon: "සවස",
      success: {
        title: "වෙන්කිරීම තහවුරු විය!",
        message: "ඔබගේ වෙන්කිරීමට ස්තූතියි. ඔබට ඉක්මනින් තහවුරු කිරීමේ විද්‍යුත් තැපෑලක් ලැබෙනු ඇත.",
        backHome: "මුල් පිටුවට",
      },
      cancelled: "ගෙවීම අවලංගු විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    },
    // Contact
    contact: {
      title: "සම්බන්ධ වන්න",
      subtitle: "ප්‍රශ්න තිබේද? අපි ඔබෙන් ඇසීමට කැමැත්තෙමු",
      name: "ඔබේ නම",
      email: "ඔබේ විද්‍යුත් තැපෑල",
      subject: "විෂය",
      message: "පණිවිඩය",
      send: "පණිවිඩය යවන්න",
      info: {
        title: "සම්බන්ධතා තොරතුරු",
        email: "විද්‍යුත් තැපෑල",
        response: "අපි සාමාන්‍යයෙන් පැය 24ක් ඇතුළත පිළිතුරු දෙමු",
      },
      success: "පණිවිඩය සාර්ථකව යවන ලදී!",
    },
    // Footer
    footer: {
      tagline: "වෘත්තීය ප්‍රංශ-සිංහල පරිවර්තන සේවා",
      quickLinks: "ඉක්මන් සබැඳි",
      contact: "සම්බන්ධතා",
      rights: "සියලු හිමිකම් ඇවිරිණි",
    },
    // Common
    common: {
      loading: "පූරණය වෙමින්...",
      error: "දෝෂයක් සිදු විය",
      tryAgain: "නැවත උත්සාහ කරන්න",
      back: "ආපසු",
      next: "ඊළඟ",
      submit: "ඉදිරිපත් කරන්න",
      cancel: "අවලංගු කරන්න",
      close: "වසන්න",
    },
  },
};

export const languages = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "si", name: "සිංහල", flag: "🇱🇰" },
];
